import { AgreeAndContinueButton } from '../shared/buttons/AgreeAndContinueButton';
import { PayNowButton } from '../shared/buttons/PayNowButton';
import { useFormContext } from 'react-hook-form';
import { ContactInformationFormType } from '../../interface/checkoutInterface';
import {
  // setIsTermsAccepted,
  setPurchaseCompleted,
} from '../../redux/slices/commonSlice';
import { ComponentConfig } from '@measured/puck';
import LoadingSpinner from '../shared/LoadingSpinner';
import { useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import {
  ReduxDispatchProps,
  ReduxSelectorProps,
} from '../../services/constants';
import { AxiosInstance } from 'axios';
import CustomTooltip from '../../../components/common/tooltip';
import { ColorProps, colorField } from '../../puck/reusable-props/color';
import { MarginProps, marginFields } from '../../puck/reusable-props/margin';
import { WidthProps, widthField } from '../../puck/reusable-props/width';
import { PaddingProps, paddingFields } from '../../puck/reusable-props/padding';
import TextCustomInput from '../../puck/reusable-props/TextCustomInput';
import { CustomizeProps } from '../../interface/commonInterface';
import {
  getcurrentDeviceType,
  getMarginStyles,
  getQuillEditorText,
} from '../../utils/helper';
import { Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../puck/reusable-props/Border';
import { getIsViewIsEdit } from '../../utils/constants';
import { boxShadows } from '../../../page-builder/puck/reusable-props/options';

export type SingleStepButtonSectionProps = {
  Button: CustomizeProps;
  TextFlag: boolean;
  ButtonText: CustomizeProps;
  border: IBorderValueProps;
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
} & ColorProps &
  MarginProps &
  PaddingProps &
  WidthProps;

export interface SingleStepButtonComponentProps
  extends ReduxSelectorProps,
    ReduxDispatchProps {
  baseService?: AxiosInstance;
}

export const SingleStepButtonSection = ({
  useAppDispatch,
  useAppSelector,
}: SingleStepButtonComponentProps): ComponentConfig<SingleStepButtonSectionProps> => {
  return {
    label: (
      <CustomTooltip title="ConfirmPurchase">
        <span>Confirm Purchase</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      Button: {
        type: 'custom',
        label: 'Button Name',
        render: ({ value, onChange, field }) => {
          return (
            <TextCustomInput
              showHover={true}
              value={value}
              onChange={onChange}
              title={field?.label}
            />
          );
        },
      },
      TextFlag: {
        type: 'custom',
        render: ({ onChange, value }) => {
          return (
            <>
              <div className="flex justify-between items-center mb-3">
                <p className="text-sm font-semibold">Show Text only on Vip</p>
                <div className="flex gap-0.5 items-center">
                  <Tooltip
                    title={'Toggle this switch to show the text only on VIP'}
                    placement="top-start">
                    <InfoIcon fontSize="small" className="h-1 w-1" />
                  </Tooltip>
                  <Switch
                    onChange={e => {
                      onChange(e.target.checked);
                    }}
                    checked={value}
                    inputProps={{ 'aria-label': 'controlled' }}
                  />
                </div>
              </div>
            </>
          );
        },
      },
      ButtonText: {
        type: 'custom',
        label: 'Text',
        render: ({ value, onChange, field }) => {
          return (
            <TextCustomInput
              showHover={true}
              value={value}
              onChange={onChange}
              title={field?.label}
            />
          );
        },
      },
      ...colorField,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border value={value} onChange={onChange} title="Border" />
        ),
      },
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
      ...widthField,
    },
    defaultProps: {
      Button: {
        weight: {
          mobile: 'font-bold',
          tablet: 'font-bold',
          desktop: 'font-bold',
        },
        deviceType: 'desktop',
        text: 'COMPLETE PURCHASE',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        hoverColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        fontSize: {
          mobile: 'text-xl',
          tablet: 'text-2xl',
          desktop: 'text-2xl',
        },
      },
      TextFlag: true,
      ButtonText: {
        weight: {
          mobile: 'font-normal',
          tablet: 'font-normal',
          desktop: 'font-normal',
        },
        deviceType: 'desktop',
        text: 'TRY IT RISK FREE! 30-DAY MONEY-BACK GUARANTEE!',
        textColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        hoverColor: {
          mobile: '#000000',
          tablet: '#000000',
          desktop: '#000000',
        },
        fontSize: {
          mobile: 'text-sm',
          tablet: 'text-sm',
          desktop: 'text-sm',
        },
      },
      margin: {
        desktop: {
          top: '8',
          bottom: '4',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '8',
          bottom: '4',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '8',
          bottom: '4',
          right: '0',
          left: '0',
        },
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
        paddingLeft: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
        paddingRight: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
        paddingTop: {
          desktop: '4',
          mobile: '4',
          tablet: '4',
        },
      },
      width: 'w-full',
      boxShadow: 'none',
      ...borderProps,
      color: {
        backgroundColor: '#FFFFFF',
        hoverColor: '#FFFFFF',
      },
    },
    render: ({
      margin,
      color,
      border,
      width,
      padding,
      Button,
      ButtonText,
      boxShadow,
      TextFlag,
      editMode,
    }) => {
      const navigate = useNavigate();
      const { pathname } = useLocation();
      const dispatch = useAppDispatch();
      const hasSubscription = useAppSelector(
        state => state.checkout.hasSubscription,
      );
      const isTermsAccepted = useAppSelector(
        state => state.common.isTermsAccepted,
      );
      const { submitSuccess, purchaseCompleted } = useAppSelector(
        state => state.common,
      );
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const checkoutState = useAppSelector(state => state.checkout);
      const isCartLoading = useAppSelector(state => state.cart.isCartLoading);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const isSetShippingApiLoading = useAppSelector(
        state => state.checkout.isSetShippingApiLoading,
      );
      const showVip = hasSubscription;
      const { formState } = useFormContext<ContactInformationFormType>();
      const isEmpty = (obj: object) =>
        obj ? Object.keys(obj).length === 0 : true;
      const [searchParams] = useSearchParams();
      const newSearchParams = new URLSearchParams(searchParams.toString());
      let navState = {};
      if (!getIsViewIsEdit() && checkoutState?.nextpageConfig?.id) {
        navState = {
          state: checkoutState?.nextpageConfig?.id
            ? {
                id: checkoutState?.nextpageConfig?.id,
                pageVisiblity: checkoutState?.nextpageConfig?.pageVisiblity,
                pageType: checkoutState?.nextpageConfig?.pageType,
              }
            : {},
        };
      }

      const state = useAppSelector(state => state);
      const newButtonText = {
        ...ButtonText,
        text: getQuillEditorText(ButtonText?.text, state),
      };
      const newButton = {
        ...Button,
        text: getQuillEditorText(Button?.text, state),
      };
      useEffect(() => {
        if (purchaseCompleted) {
          navigate(pathname + '?' + newSearchParams.toString(), navState);
          dispatch(setPurchaseCompleted(false));
        }
      }, [purchaseCompleted]);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      return (
        <>
          <div
            style={{
              ...marginStyles,
            }}>
            <div
              className={`relative flex justify-center items-center ${boxShadow}`}
              style={{ margin: 0 }}>
              {showVip && !isTermsAccepted ? (
                <AgreeAndContinueButton
                  // setIsTermsAccepted={setIsTermsAccepted}
                  useAppDispatch={useAppDispatch}
                  useAppSelector={useAppSelector}
                  showVip={showVip || !TextFlag}
                  Button={newButton}
                  ButtonText={newButtonText}
                  currentDeviceType={currentDeviceType}
                  styles={{
                    backgroundColor: color?.backgroundColor,
                    hoverColor: color?.hoverColor,
                    border: border,
                    width: width,
                    padding: padding,
                  }}
                />
              ) : (
                <PayNowButton
                  useAppDispatch={useAppDispatch}
                  useAppSelector={useAppSelector}
                  showVip={showVip || !TextFlag}
                  Button={newButton}
                  isButton={false}
                  isAutoselect={false}
                  currentDeviceType={currentDeviceType}
                  ButtonText={newButtonText}
                  styles={{
                    backgroundColor: color?.backgroundColor,
                    hoverColor: color?.hoverColor,
                    border: border,
                    width: width,
                    padding: padding,
                  }}
                />
              )}
              {(submitSuccess ||
                isCartLoading ||
                isSetShippingApiLoading > 0) && (
                <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-90">
                  <div className="h-9">
                    <LoadingSpinner />
                  </div>
                </div>
              )}
            </div>
          </div>
          {!isEmpty(formState?.errors) && (
            <div className="text-red-500 text-xs sm:text-right mt-1">
              * Please fix the errors mentioned above.
            </div>
          )}
        </>
      );
    },
  };
};
